import React, { PropTypes } from 'react';
import { Field } from 'redux-form';
import classnames from 'classnames';
import { TextInputField } from 'common/components/form_fields';
import Icon from 'common/components/svg_icon';

const Form = ({ handleSubmit, handlePrev, handleNext, handleLast, currentPage, pageCount }) => {
  const prevClasses = classnames('btn btn-utility btn-lg btn-with-icon', {
    invisible: currentPage === 1
  });

  const nextClasses = classnames('btn btn-utility btn-lg btn-with-icon', {
    invisible: currentPage >= pageCount
  });

  return (
    <form onSubmit={handleSubmit}>
      <button onClick={handlePrev} type="button" className={prevClasses}>
        <Icon className="svg-icon" icon="arrowLeft" />
        {' '}<span className="hide-for-small-only">Prev</span>
      </button>
      <div className="pages">
        <Field component={TextInputField} name="page" />
        <div className="page-count">of{' '}
          <button type="button" className="last-page" onClick={handleLast}>
            { Math.max(pageCount, currentPage) }
          </button>
        </div>
      </div>
      <button onClick={handleNext} type="button" className={nextClasses}>
        <span className="hide-for-small-only">Next</span>{' '}
        <Icon className="svg-icon" icon="arrowRight" />
      </button>
    </form>
  );
}

Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handlePrev: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  handleLast: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
};

export default Form;



// WEBPACK FOOTER //
// ./common/pager/components/form.jsx